import { ReplaceRowCombinedProps } from './types';

const usePresenter = (props: ReplaceRowCombinedProps): ReplaceRowCombinedProps => {
  return props;
};

export default usePresenter;
